import React from 'react';
import Moviesa from './Moviesa';
import Moviesb from './Moviesb';

const favSeries = "Moviesa";

const FavS = () => {
    if(favSeries === "Moviesb"){
        return <Moviesa />
    } else {
        return <Moviesb />
    }
}

const Appp = () =>(
   <>
       <FavS />
   </>
)
export default Appp;